module.exports = __webpack_public_path__ + "img/recoleta.367c35bf.jpg";